import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=8b056c1a&scoped=true"
import script from "./Websites.vue?vue&type=script&lang=js"
export * from "./Websites.vue?vue&type=script&lang=js"
import style0 from "./Websites.vue?vue&type=style&index=0&id=8b056c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b056c1a",
  null
  
)

export default component.exports